import { createReducer, on } from '@ngrx/store';
import * as fromPerimeterActions from '../actions/perimeters.actions';
import { PerimeterFirebaseResponse } from '../../models/perimeters.model';

export interface PerimeterState {
    data: PerimeterFirebaseResponse;
    loaded: boolean;
    loading: boolean;
    error: string;
}

export const initialState: PerimeterState = {
    data: undefined as any,
    loaded: false,
    loading: false,
    error: ''
};

export const perimeterReducer = createReducer(
    initialState,
    on(fromPerimeterActions.LoadPerimeterAction, (state) => ({ ...state, loading: true })),
    on(fromPerimeterActions.LoadPerimeterSuccessAction, (state, { data }) => ({ ...state, data, loaded: true, loading: false })),
    on(fromPerimeterActions.LoadPerimeterFailAction, (state, { error }) => ({ ...state, error: error.message })),
    on(fromPerimeterActions.AddPerimeterAction, (state) => ({ ...state, loading: true })),
    on(fromPerimeterActions.AddPerimeterSuccessAction, (state, { data }) => ({ ...state, data, loaded: true, loading: false })),
    on(fromPerimeterActions.AddPerimeterFailAction, (state, { error }) => ({ ...state, error: error.message })),
    on(fromPerimeterActions.UpdatePerimeterAction, (state) => ({ ...state, loading: true })),
    on(fromPerimeterActions.UpdatePerimeterSuccessAction, (state, { data }) => ({ ...state, data: { ...state.data, registers: data.registers }, loaded: true, loading: false })),
    on(fromPerimeterActions.UpdatePerimeterFailAction, (state, { error }) => ({ ...state, error: error.message })),
);
